import React, { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import ChiSiamo from "@/components/ChiSiamo";
import Services from "@/components/Services";
import Approach from "@/components/Approach";
import Challenge from "@/components/Challenge";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

let lenisInstance = null;

export const scrollToTarget = (target) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -72, duration: 1.4 });
  } else if (typeof target === "number") {
    window.scrollTo({ top: target, behavior: "smooth" });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-obsidian text-ink flex items-center justify-center font-body p-8 text-center">
          <p>Qualcosa è andato storto. Ricarica la pagina.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  const rafRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisInstance = lenis;
    const raf = (time) => {
      lenis.raf(time);
      rafRef.current = requestAnimationFrame(raf);
    };
    rafRef.current = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafRef.current);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="relative bg-obsidian text-ink font-body overflow-x-clip">
        <div className="noise-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <ChiSiamo />
          <Services />
          <Approach />
          <Challenge />
          <Contact />
        </main>
        <Footer />
        <Toaster richColors position="bottom-right" theme="dark" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
